var _path, _rect, _rect2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRearRack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 102,
    viewBox: "0 0 160 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 85C155 86.6382 154.286 88.2252 151.498 89.9294C148.518 91.7514 143.774 93.2622 137.193 94.3835C124.106 96.6134 105.777 97 85 97C64.2817 97 45.9364 96.3663 32.8508 94.0162C26.2665 92.8337 21.4814 91.2921 18.4633 89.4841C15.5697 87.7508 15 86.2604 15 85C15 46.3401 46.3401 15 85 15C123.66 15 155 46.3401 155 85Z",
    stroke: "#D9D9D9",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 85,
    width: 150,
    height: 17,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7303,
    y: 80,
    width: 7,
    height: 21,
    rx: 2,
    transform: "rotate(48.5091 15.7303 80)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C10 0.89543 10.8954 0 12 0H148C149.105 0 150 0.895431 150 2V8C150 9.10457 149.105 10 148 10H10V2Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.64893L14.2406 6.99994L63.1566 85.307C63.7418 86.2438 63.4567 87.4777 62.5199 88.0629L61.6718 88.5927C60.735 89.1778 59.5011 88.8928 58.9159 87.956L10 9.64893Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 6.34619L41.8154 5.00005L64.1371 84.8486C64.4345 85.9124 63.8132 87.0158 62.7494 87.3132L61.7863 87.5824C60.7226 87.8798 59.6191 87.2585 59.3217 86.1948L37 6.34619Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRearRack);
export default __webpack_public_path__ + "static/media/RearRack.c7d5cbfef8830acdbc1dc954b600388d.svg";
export { ForwardRef as ReactComponent };